module.exports = __webpack_public_path__ + "media/images/icon-warning-outline-c87779f9056c2c6079579d64fa8fc853.svg";